import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { AsyncUpdateStatus, AsyncUpdateStatusDefault } from './../shared/async-update-status.store';
import { SiteRole } from './models';

export interface State extends EntityState<SiteRole> {
    templatesLoadingStatus: AsyncUpdateStatus;
    currentSiteRolesLoadingStatus: AsyncUpdateStatus;
}

export const adapter: EntityAdapter<SiteRole> = createEntityAdapter<SiteRole>();

export const initialState: State = adapter.getInitialState({
    templatesLoadingStatus: AsyncUpdateStatusDefault,
    currentSiteRolesLoadingStatus: AsyncUpdateStatusDefault,
});
